import { MenuItem } from "./model/menu-item.model";

export function flattenMenuItems(menuItemOrItems: MenuItem | MenuItem[]): MenuItem[] {
    if (!menuItemOrItems) {
        return [];
    }
    const menuItems = Array.isArray(menuItemOrItems) ? menuItemOrItems : [menuItemOrItems];
    return menuItems.reduce((acc, curr) => [...acc, curr, ...flattenMenuItems(curr.children)], []);
}
